/* Dopekicks shared countdown (flip clock) + copy-code helper. Used by dk-flash-sale and dk-countdown-bar. */
(function () {
  if (window.DkCountdown) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function setFlip(box, val) {
    if (box.dataset.v === val) return;
    var old = box.dataset.v;
    box.dataset.v = val;
    var top = box.querySelector('.fc__top span'), bot = box.querySelector('.fc__bot span'),
        ft = box.querySelector('.fc__flap-t span'), fb = box.querySelector('.fc__flap-b span');
    if (old === undefined || reduce || document.hidden) {
      top.textContent = bot.textContent = ft.textContent = fb.textContent = val;
      return;
    }
    top.textContent = val; fb.textContent = val;
    ft.textContent = old; bot.textContent = old;
    box.classList.remove('is-flip'); void box.offsetWidth; box.classList.add('is-flip');
    clearTimeout(box._t);
    box._t = setTimeout(function () {
      bot.textContent = val; ft.textContent = val;
      box.classList.remove('is-flip');
    }, 620);
  }

  /* root: element containing .fc[data-u="d|h|m|s"]
     o: { start, end, onState(state, msLeft) }  state = before | during | ended | none */
  window.DkCountdown = function (root, o) {
    var start = Date.parse(o.start || ''), end = Date.parse(o.end || '');
    var boxes = {};
    root.querySelectorAll('.fc[data-u]').forEach(function (b) { boxes[b.dataset.u] = b; });
    var iv;
    function tick() {
      var now = Date.now(), target, state;
      if (!isNaN(start) && now < start) { target = start; state = 'before'; }
      else if (!isNaN(end) && now < end) { target = end; state = 'during'; }
      else { state = (isNaN(start) && isNaN(end)) ? 'none' : 'ended'; }
      if (state === 'ended' || state === 'none') {
        clearInterval(iv);
        o.onState && o.onState(state, 0);
        return;
      }
      var ms = target - now, s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400); s %= 86400;
      if (boxes.d) setFlip(boxes.d, pad(d));
      if (boxes.h) setFlip(boxes.h, pad(Math.floor(s / 3600)));
      if (boxes.m) setFlip(boxes.m, pad(Math.floor((s % 3600) / 60)));
      if (boxes.s) setFlip(boxes.s, pad(s % 60));
      root.classList.toggle('has-days', d > 0);
      root.classList.toggle('is-urgent', ms < 3600000);
      o.onState && o.onState(state, ms);
    }
    tick();
    iv = setInterval(tick, 1000);
    return { stop: function () { clearInterval(iv); } };
  };

  /* Scheduled display: keep el hidden until showFrom, then reveal (no reload). Always shown in theme editor. */
  window.DkSchedule = function (el, showFrom, onShow) {
    var t = Date.parse(showFrom || ''), shown = false;
    function show() { if (shown) return; shown = true; el.style.display = ''; onShow && onShow(); }
    if (isNaN(t) || (window.Shopify && Shopify.designMode)) { show(); return; }
    if (Date.now() >= t) { show(); return; }
    el.style.display = 'none';
    var iv = setInterval(function () { if (Date.now() >= t) { clearInterval(iv); show(); } }, 1000);
  };

  /* Re-render the section from the server (Section Rendering API) and swap in the parts that
     were masked before the sale started (code box, CTA link). Retries if the server still masks. */
  window.DkRefreshCode = function (root, selectors, tries) {
    tries = tries || 0;
    var id = root.dataset.sectionId;
    if (!id) return;
    var url = location.pathname + '?section_id=' + encodeURIComponent(id) + '&dkt=' + Date.now();
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(root.id);
      if (!fresh) return;
      if (fresh.dataset.masked === '1') {
        if (tries < 8) setTimeout(function () { DkRefreshCode(root, selectors, tries + 1); }, 15000);
        return;
      }
      selectors.forEach(function (sel) {
        var a = root.querySelectorAll(sel), b = fresh.querySelectorAll(sel);
        a.forEach(function (n, i) { if (b[i]) n.replaceWith(document.importNode(b[i], true)); });
      });
      root.dataset.masked = '0';
    }).catch(function () {
      if (tries < 8) setTimeout(function () { DkRefreshCode(root, selectors, tries + 1); }, 15000);
    });
  };

  window.DkCopy = function (btn, code, labelEl, copiedText) {
    var orig = labelEl ? labelEl.textContent : '';
    function done() {
      btn.classList.add('is-copied');
      if (labelEl) labelEl.textContent = copiedText || 'Copied!';
      setTimeout(function () { btn.classList.remove('is-copied'); if (labelEl) labelEl.textContent = orig; }, 1800);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); done();
    }
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
    else fallback();
  };
})();
